import { render, staticRenderFns } from "./UnitSelect.vue?vue&type=template&id=456162e8&scoped=true";
import script from "./UnitSelect.vue?vue&type=script&lang=js";
export * from "./UnitSelect.vue?vue&type=script&lang=js";
import style0 from "./UnitSelect.vue?vue&type=style&index=0&id=456162e8&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "456162e8", null);
export default component.exports;